import { render } from "./OapPopup.vue?vue&type=template&id=ef2163cc"
import script from "./OapPopup.vue?vue&type=script&lang=js"
export * from "./OapPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__